/* LithiumPro – sortering efter kapacitet (Ah) på batteri-kollektioner.
   Indlæses kun på kollektioner, hvor alle produkttyper er batterier (se sections/lp-capsort.liquid).
   Tilføjer "Kapacitet, lav til høj / høj til lav" i "Sorter efter". Ved valg henter scriptet alle
   sider i kollektionen (med aktive filtre) og sorterer produkterne efter Ah (Wh som tiebreak). */
(function () {
  var OPTIONS = [
    { value: 'kapacitet-stigende', label: 'Kapacitet, lav til høj', dir: 1 },
    { value: 'kapacitet-faldende', label: 'Kapacitet, høj til lav', dir: -1 }
  ];
  var running = false;

  function current() {
    var v = new URLSearchParams(location.search).get('sort_by') || '';
    for (var i = 0; i < OPTIONS.length; i++) if (OPTIONS[i].value === v) return OPTIONS[i];
    return null;
  }
  function num(s) { return parseFloat(String(s).replace(',', '.')); }

  function capacity(title) {
    var ah = null, wh = null, volt = null, m;
    title = title || '';
    m = title.match(/(\d+(?:[.,]\d+)?)\s*V\b/);
    if (m) volt = num(m[1]);
    m = title.match(/(\d+(?:[.,]\d+)?)\s*(?:[-\/]\s*\d+(?:[.,]\d+)?\s*)?A[Hh]\b/);
    if (m) ah = num(m[1]);
    m = title.match(/(\d+(?:[.,]\d+)?)\s*kWh/i);
    if (m) wh = num(m[1]) * 1000;
    if (wh === null) { m = title.match(/(\d+(?:[.,]\d+)?)\s*Wh\b/); if (m) wh = num(m[1]); }
    if (ah === null && wh !== null) ah = wh / (volt || 51.2);
    if (wh === null && ah !== null && volt) wh = ah * volt;
    return { ah: ah, wh: wh };
  }

  function titleOf(li) {
    var best = '';
    li.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > best.length) best = t;
    });
    return best || (li.textContent || '');
  }
  function handleOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return null;
    return (a.pathname.split('/products/')[1] || '').split('/')[0] || null;
  }

  /* Tilføj valgmuligheder i både den rigtige <select> og temaets pæne dropdown */
  function addOptions() {
    var sel = document.getElementById('sort_by');
    if (!sel) return false;
    var cur = current();
    OPTIONS.forEach(function (o) {
      var exists = false;
      for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === o.value) exists = true;
      if (!exists) {
        var opt = document.createElement('option');
        opt.value = o.value; opt.textContent = o.label;
        sel.appendChild(opt);
      }
    });
    if (cur) sel.value = cur.value;
    var clone = document.querySelector('.sort_by_clone');
    if (cur && clone) clone.value = cur.value;

    var wrap = sel.parentElement;
    var ui = wrap && wrap.querySelector('.bv_ul_inner');
    if (!ui) return false;
    var tpl = ui.querySelector('span.li:not(.nofocus)');
    if (!tpl) return false;
    var have = {};
    ui.querySelectorAll('span.li').forEach(function (s) { have[(s.textContent || '').trim()] = s; });
    OPTIONS.forEach(function (o) {
      if (ui.querySelector('[data-lp-cap="' + o.value + '"]')) return;
      if (have[o.label]) { have[o.label].setAttribute('data-lp-cap', o.value); return; }
      var item = tpl.cloneNode(true);
      item.classList.remove('bv_selected');
      item.setAttribute('data-lp-cap', o.value);
      var txt = item.querySelector('.text');
      if (txt) txt.textContent = o.label; else item.textContent = o.label;
      item.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }, true);
      ui.appendChild(item);
    });
    if (cur) {
      var selItem = ui.querySelector('[data-lp-cap="' + cur.value + '"]');
      if (selItem) {
        ui.querySelectorAll('span.li.bv_selected').forEach(function (s) { s.classList.remove('bv_selected'); });
        selItem.classList.add('bv_selected');
        var main = wrap.querySelector('.bv_atual .sl_inner');
        if (main) main.textContent = cur.label;
      }
    }
    return true;
  }
  function ensureOptions() {
    var tries = 0;
    (function tick() {
      if (addOptions() || ++tries > 40) return;
      setTimeout(tick, 150);
    })();
  }

  function hidePagination(scope) {
    scope.querySelectorAll('nav.n6pg, #load-more-info').forEach(function (e) { e.style.display = 'none'; });
    scope.querySelectorAll('#load-more-button').forEach(function (e) {
      var p = e.closest('p') || e; p.style.display = 'none';
      var hr = p.previousElementSibling;
      if (hr && hr.tagName === 'HR') hr.style.display = 'none';
    });
  }

  function refreshTheme() {
    try { window.dispatchEvent(ratingsEvt); } catch (e) {}
    try { window.dispatchEvent(semanticInputEvt); } catch (e) {}
    try { window.dispatchEvent(schemeTooltipEvt); } catch (e) {}
    try { window.dispatchEvent(popupsEvt); } catch (e) {}
    try { window.dispatchEvent(listScrollableEvt); } catch (e) {}
    try { window.dispatchEvent(productVariantsEvt); } catch (e) {}
    try { window.dispatchEvent(productcardVariantsEvt); } catch (e) {}
    try { window.dispatchEvent(formZindexEvt); } catch (e) {}
    try { window.check_limit_event(); } catch (e) {}
    try { ajaxCart.init(); } catch (e) {}
    try { quickShop.init(); } catch (e) {}
  }

  async function sortAll() {
    var cur = current();
    var list = document.getElementById('collection');
    if (!cur || running || !list || list.getAttribute('data-lp-sorted') === cur.value) return;
    var form = document.getElementById('filter');
    var sid = form && form.getAttribute('data-template');
    if (!sid) return;
    running = true;
    list.classList.add('processing');
    try {
      var params = new URLSearchParams(location.search);
      params.delete('page'); params.delete('sort_by'); params.delete('section_id');
      var items = [];
      for (var p = 1; p <= 30; p++) {
        params.set('page', p);
        var res = await fetch(location.pathname + '?section_id=' + encodeURIComponent(sid) + '&' + params.toString());
        if (!res.ok) break;
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        var ul = doc.getElementById('collection');
        if (!ul) break;
        var lis = Array.prototype.slice.call(ul.children);
        if (!lis.length) break;
        items = items.concat(lis);
        if (!doc.querySelector('#load-more-button[data-next], nav.n6pg li.next a')) break;
      }
      if (!items.length) return;
      var seen = {}, rows = [];
      items.forEach(function (li, idx) {
        var h = handleOf(li);
        if (h && seen[h]) return;
        if (h) seen[h] = 1;
        var c = capacity(titleOf(li));
        rows.push({ li: li, ah: c.ah, wh: c.wh, i: idx });
      });
      rows.sort(function (a, b) {
        if (a.ah === null && b.ah === null) return a.i - b.i;
        if (a.ah === null) return 1;
        if (b.ah === null) return -1;
        if (a.ah !== b.ah) return (a.ah - b.ah) * cur.dir;
        var wa = a.wh || 0, wb = b.wh || 0;
        if (wa !== wb) return (wa - wb) * cur.dir;
        return a.i - b.i;
      });
      list.innerHTML = '';
      rows.forEach(function (r) { list.appendChild(document.importNode(r.li, true)); });
      list.setAttribute('data-lp-sorted', cur.value);
      hidePagination(list.closest('[id^="shopify-section-"]') || document);
    } catch (err) {
      console.log('lp-capsort', err);
    } finally {
      list.classList.remove('processing');
      running = false;
      refreshTheme();
    }
  }

  function init() { ensureOptions(); sortAll(); }
  window.addEventListener('collectionSort', function () { setTimeout(init, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();